
export default (uuid) => {
  return uuid.toString().slice(-8)
}
